/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import { FullLogo, GoogleImg } from "../Assets/Images";
import { GoogleLogin } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { doLogin } from "../Redux/Actions/AuthActions";
import Loader from "../Components/Loader";

export default function Login(props) {
  const loading = useSelector((state) => state.Auth.loading);
  const dispatch = useDispatch();
  const clientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  const onSuccess = (response) => {
    console.log("response", response);
    if (response.accessToken) {
      dispatch(
        doLogin({
          token: response.tokenId,
          accessToken: response.response,
          googleId: response.googleId,
          profileObj: response.profileObj,
          tokenObj: response.tokenObj,
        })
      );
    }
  };

  const onFailure = (error) => {
    console.log(error);
  };
  // Modern Google OAuth implementation
  const handleGoogleSuccess = (credentialResponse) => {
    console.log('Google login success:', credentialResponse);
    // Note: This would need backend integration to decode the JWT token
    // For now, we'll maintain the same structure as the old implementation
    const mockResponse = {
      accessToken: credentialResponse.credential,
      tokenId: credentialResponse.credential,
      googleId: 'placeholder-id',
      profileObj: { name: 'User', email: 'user@example.com', imageUrl: '' },
      tokenObj: { access_token: credentialResponse.credential }
    };
    onSuccess(mockResponse);
  };
  
  const handleGoogleError = () => {
    console.log('Google login failed');
    onFailure('Google login failed');
  };
  
  const loaded = true; // Always loaded with new implementation
  if (loading) {
    return <Loader />;
  }
  return (
    <>
      <div className="main-page w-full h-screen relative"></div>
      <div className="main-page-overlay w-full h-screen absolute top-0 left-0"></div>
      <div className="sign-up rounded-lg w-1/4 absolute bg-white text-center">
        <div className="allcolor py-10">
          <img
            className=" table mx-auto"
            src={FullLogo}
            style={{ width: "320px" }}
          />
        </div>
        <div className="py-8">
          {loaded && (
            <div className="flex justify-center">
              <GoogleLogin
                onSuccess={handleGoogleSuccess}
                onError={handleGoogleError}
                useOneTap={false}
                theme="filled_blue"
                size="large"
                text="signin_with"
                shape="rectangular"
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
